// src/com/sms_sent/SmsSentCustList.js
import React, { useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import FlexyTable from '../common/flexytable/FlexyTable';
import { ContentHeader, HeaderLeft } from '../common/CvoStyled';
import SearchBox from '../common/SearchBox';
import { Button, TextField } from '@mui/material';
import { TableColumnType } from '../../model/AppConst';

const CustListContainer = styled(Box)({
    flexGrow:1,
    display: 'flex', flexDirection: 'column', // backgroundColor: 'orange',
});


const TableColumns = [
    { id: 'custName', label: '업체명', width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'smsLen', label: '전송횟수', width: 60, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    { id: 'tranDate', label: '시작날짜', width: 100, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    { id: 'custId', label: '업체ID', width: 100, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
];

export default function SmsSentCustList({
    records,
    onClickItem,
    dateSelected,
    onChangeDate,
    onRequestGetList,
    responseList,
}) {
    const [search, setSearch] = useState('');

    const onChangeSearch = (text) => {
        setSearch(text);
    };

    const onChangeDateValue = (event) => {
        onChangeDate(event.target.value);
    };

    return(
        <CustListContainer>
            <ContentHeader>
                <HeaderLeft>
                    <TextField
                        type='date'
                        label="시작날짜"
                        value={dateSelected||''}
                        size="small"
                        onChange={onChangeDateValue}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onRequestGetList}
                        style={{marginLeft:5, marginRight:5}}
                        disabled={responseList.loading}
                    >
                        조회
                    </Button>
                    <SearchBox
                        value={search}
                        onChange={onChangeSearch}
                        width={120}
                        disabled={records.length === 0}
                    />
                </HeaderLeft>
            </ContentHeader>
            <FlexyTable
                name="sms_sent_group_by_cust"
                uniqueKey="custId"
                columns={TableColumns}
                records={records}
                search={search}
				onClickOneRow={onClickItem}
                hideColumnConfig={true}
            />
        </CustListContainer>
    );
}